import React from 'react'
import { AlertCircleIcon } from 'src/editor/shared/icons/alert-circle-icon'
import { v4 as uuid } from 'uuid'
import { ButtonSizeEnum, ButtonTypeEnum } from '../../buttons'
import { Radio } from '../../radio'
import {
  DialogWindow,
  DialogWindowIconThemeEnum,
  DialogWindowProps,
} from './dialog-window'

export interface OptionsDialogWindowProps
  extends Omit<DialogWindowProps, 'icon' | 'iconTheme'> {
  options: {
    id: number
    label: string
  }[]
  activeOptionId: number | null
  onChangeActiveOptionId: (id: number) => void
}

const RADIO_NAME = `radio-option-dialog-${uuid()}`

export const OptionsDialogWindow = (props: OptionsDialogWindowProps) => {
  return (
    <DialogWindow
      icon={<AlertCircleIcon />}
      iconTheme={DialogWindowIconThemeEnum.Warning}
      modalWindowFooterClassName="justify-end"
      cancelButtonProps={{
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Medium,
        disabled: !props.activeOptionId,
      }}
      {...props}
    >
      {props.options.map(option => (
        <Radio
          key={option.id}
          name={RADIO_NAME}
          onChange={() => props.onChangeActiveOptionId(option.id)}
          isChecked={props.activeOptionId === option.id}
        >
          {option.label}
        </Radio>
      ))}
    </DialogWindow>
  )
}
